import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, ElementRef, QueryList, ViewChildren, signal } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import Swiper from 'swiper';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import AOS from 'aos';




import {
  Navigation,
  Pagination,
  Autoplay,
  Mousewheel
} from 'swiper/modules';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ConsentformComponent } from '../../../../other_information/consentform/consentform.component';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../../../services/common.service';
import { finalize } from 'rxjs';
import { response } from 'express';
import { SuccessModalComponent } from '../../../../reusable-component/success-modal/success-modal.component';
import { trigger, transition, style, animate } from '@angular/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { MatBottomSheet, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { ThemeModalComponent } from '../../../../shared/theme-modal/theme-modal.component';


Swiper.use([
  Navigation,
  Pagination,
  Autoplay,
  Mousewheel
]);
// Import Swiper CSS
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
export interface FaqItem {
  id: number;
  title: string;
  content: string;
  points?: string[];
  open: boolean;
  contentTwo?: string
}

@Component({
  selector: 'app-grouptherapy',
  standalone: true,
  imports: [CommonModule, MatBottomSheetModule, FontAwesomeModule, MatSelectModule, MatFormFieldModule, ReactiveFormsModule, SuccessModalComponent],
  templateUrl: './grouptherapy.component.html',
  styleUrl: './grouptherapy.component.css',
    animations: [
    trigger('faqAnimation', [
      transition(':enter', [
        style({ height: '0px', opacity: 0 }),
        animate('500ms ease', style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1 }),
        animate('500ms ease', style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})
export class GrouptherapyComponent {
  faChevronUp = faChevronUp;
  faChevronDown = faChevronDown;
  @ViewChildren('swiperRef')
  swiperRefs!: QueryList<ElementRef>;
  isSuccessModalVisible = false;
  successTitle = '';
  successMessage = '';
  

  groups = [
    'Placement Anxiety',
    'Relationship Uncertainty',
    'Self-Worth & Identity',
    'Adjusting to a New Environment',
    'Loneliness & Disconnection',
    'Caregiver Support'
  ];

  contactForm!: FormGroup

  selectedGroups: string[] = [];
  submitted = false;
  isSubmitting: boolean = false;
  isZoom110 = false;



  clearGroups(event: Event): void {
    event.stopPropagation();
    this.contactForm.patchValue({
      groups: []
    });
  }

  pillars = [
    {
      img: 'assets/img/service/grouptherapy/vision.png',
      icon: 'A',
      title: 'Awareness',
      content: 'Greater self-awareness through others perspectives',
    },
    {
      img: 'assets/img/service/grouptherapy/Vector.png',
      icon: 'C',
      title: 'Connection',
      content: 'Reduced isolation through shared experiences',
    },
    {
      img: 'assets/img/service/grouptherapy/plant-growth.png',
      icon: 'G',
      title: 'Growth',
      content: 'Practice of new ways of relating in a safe, moderated environment',
    },
  ];

  format = [
    { label: 'Frequency', value: 'Once a week', img: 'assets/img/service/grouptherapy/freuensy.png' },
    { label: 'Duration', value: '75 minutes per session', img: 'assets/img/service/grouptherapy/duration.png' },
    { label: 'Structure', value: '4-session closed group programme', img: 'assets/img/service/grouptherapy/department-structure.png' },
    { label: 'Fee', value: 'Rs 2600 full programme', img: 'assets/img/service/grouptherapy/indian-rupee-sign.png' },
  ];

  themes = signal<any[]>([
    {
      active: true,
      backgroundColor: '#E5EEFF',
      img: 'assets/img/service/grouptherapy/slide1.png',
      imgActive: 'assets/img/service/grouptherapy/active1.png',
      cardImg:  'assets/img/service/grouptherapy/descImg1.png',
      tone: 'blue',
      icon: 'P',
      title: 'Placement Anxiety',
      subtitle: 'When pressure and overthinking begin to take over.',
      helps: [
        'Recognise anxiety patterns in thoughts and behaviour',
        'Understand comparison and pressure triggers',
        'Respond with more clarity and steadiness',
      ],
      format:
        'A 4-week structured experience with guided exercises and real-time application helping you move from overwhelm to clarity.',
    },
    {
      active: false,
      backgroundColor: '#FFF8E5',
      img: 'assets/img/service/grouptherapy/slide2.png',
      imgActive: 'assets/img/service/grouptherapy/active2.png',
      cardImg:  'assets/img/service/grouptherapy/descImg2.png',
      tone: 'cream',
      icon: 'R',
      title: 'Relationship Uncertainty',
      subtitle: 'When you feel stuck between your feelings, theirs, and what comes next.',
      helps: [
        'Identify your relationship patterns as they play out',
        'Understand emotional triggers and attachment responses',
        'Practice clearer boundaries and communication',
      ],
      format:
        'A 4-week experiential journey where you do not just analyse relationships, but actively work through your patterns and responses.',
    },
    {
      active: false,
      backgroundColor: '#E5FFEC',
      img: 'assets/img/service/grouptherapy/slide3.png',
      imgActive: 'assets/img/service/grouptherapy/active3.png',
      cardImg:  'assets/img/service/grouptherapy/descImg3.png',
      tone: 'mint',
      icon: 'W',
      title: 'Self-Worth & Identity ',
      subtitle: 'When your sense of self feels dependent on outcomes, validation, or comparison.',
      helps: [
        'Recognise the voice of the inner critic',
        'Understand where your self-worth patterns come from',
        'Begin building a more stable, internal sense of self ',
      ],
      format:
        'A 4-week guided process combining reflection, exercises, and shared insight to help you shift how you see yourself.',
    },
    {
      active: false,
      backgroundColor: '#E5F9FF',
      img: 'assets/img/service/grouptherapy/tree-sapling1.png',
      imgActive: 'assets/img/service/grouptherapy/active4.png',
      cardImg:  'assets/img/service/grouptherapy/descImg4.png',
      tone: 'mint',
      icon: 'W',
      title: 'Adjusting to a Change ',
      subtitle: 'When you’re navigating change, and nothing feels fully familiar yet. ',
      helps: [
        'Process the emotional impact of transitions  ',
        'Understand your response to change and uncertainty  ',
        'Build grounding and adjustment strategies'
      ],
      format:
        'A 4-week structured group experience designed to help you move from feeling unsettled to more anchored and adaptable. ',
    },
    {
      active: false,
      backgroundColor: '#E5E7FF',
      img: 'assets/img/service/grouptherapy/person-simple1.png',
      imgActive: 'assets/img/service/grouptherapy/active5.png',
      cardImg:  'assets/img/service/grouptherapy/descImg5.png',
      tone: 'mint',
      icon: 'W',
      title: 'Loneliness & Disconnection  ',
      subtitle: 'When you feel distant from others, or even from yourself. ',
      helps: [
        'Explore patterns that create or sustain disconnection ',
        'Understand your relational needs more deeply',
        'Practice ways of connecting more meaningfully'
      ],
      format:
        'A 6-week immersive experience with guided sharing, reflection, and relational exercises that help you move towards connection not just understand the lack of it.  ',
    },
    {
      active: false,
      backgroundColor: '#FFE5E5',
      img: 'assets/img/service/grouptherapy/slide21.png',
      imgActive: 'assets/img/service/grouptherapy/active6.png',
      cardImg:  'assets/img/service/grouptherapy/descImg6.png',
      tone: 'mint',
      icon: 'W',
      title: 'Caregiver Support ',
      subtitle: 'When you’re always there for others, leaving little space for yourself.',
      helps: [
        'Recognise signs of emotional fatigue and burnout',
        'Understand patterns of over-responsibility and guilt',
        'Build sustainable ways of caring - for others and yourself',

      ],
      format:
        'A 4-week structured journey combining reflection, practical tools, and group support to help you restore balance and emotional capacity.   ',
    },




  ]);

  showTheme = signal<any>(this.themes()[0])

  faqs: FaqItem[] = [
    {
      id: 1,
      title: 'How is group therapy different from 1:1 therapy?',
      content: `
      Research in psychotherapy, particularly within group psychotherapy,
      consistently shows that group settings enhance outcomes through what are
      known as therapeutic factors including:
    `,
      points: [
        'Interpersonal feedback',
        'Shared emotional experiences',
        'Normalisation of distress',
        'Development of relational skills'
      ],
      open: true,
    },

    {
      id: 2,
      title: 'How is it different from individual therapy?',
      content: `
      Individual therapy focuses on one-to-one exploration, whereas group
      therapy introduces <strong>interpersonal dynamics as part of the therapeutic
      process.</strong>

      Clients benefit not only from the therapist’s input, but also from
      <strong>observing, relating to, and receiving feedback from others,</strong> making it especially effective for relational and emotional patterns. 
      These processes allow clients not only to understand themselves internally, but also to observe and shift <strong>relational patterns as they unfold live</strong>`,
      open: false,
    },

    {
      id: 3,
      title: 'What is group therapy?',
      content: `
      Group therapy is a form of psychotherapy where a small group of individuals meets regularly with a trained therapist to explore emotional, behavioural, and relational concerns. It is guided, structured, and clinically facilitated.
    `,
      open: false,
    },

    {
      id: 4,
      title: 'How is confidentiality maintained?',
      content: `
      Confidentiality is a core principle of group therapy. All participants are required to <strong>commit to strict confidentiality agreements,</strong> and therapists actively reinforce boundaries and ethical guidelines to ensure a safe and respectful space.
    `,
      open: false,
    },

    {
      id: 5,
      title: 'Can I attend just one session?',
      content: `
      No. Group therapy at Mannkaa is designed as a structured programme, not a drop-in service. Consistent attendance is essential for:
    `,
      points: [
        'Building trust within the group',
        'Maintaining therapeutic continuity',
        'Ensuring meaningful outcomes'
      ],
      contentTwo: `Participants are expected to attend <strong>most, if not all, sessions.</strong>`,
      open: false,
    },
  ];

  constructor(
    private fb: FormBuilder,
    private titleService: Title,
    private metaService: Meta,
    private commonService: CommonService,
      private bottomSheet: MatBottomSheet,
    @Inject(DOCUMENT) private document: Document
  ) {
    const canonicalUrl = 'https://www.mannkaa.com/services/group-therapy';
    const head = this.document.getElementsByTagName('head')[0];
    let canonical = this.document.querySelector("link[rel='canonical']") as HTMLLinkElement | null;

    if (!canonical) {
      canonical = this.document.createElement('link') as HTMLLinkElement;
      head.appendChild(canonical);
    }

    canonical.setAttribute('rel', 'canonical');
    canonical.setAttribute('href', canonicalUrl);

    this.titleService.setTitle('Group Therapy Programmes | Mannkaa');
    this.metaService.addTags([
      {
        name: 'description',
        content:
          'Join Mannkaa group therapy programmes designed around structured, clinician-led experiences for awareness, connection, and emotional growth.',
      },
      {
        name: 'keywords',
        content:
          'group therapy, group counselling, guided therapy programme, Mannkaa group therapy',
      },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'mannkaa' },
      { property: 'og:title', content: 'Group Therapy Programmes | Mannkaa' },
      {
        property: 'og:description',
        content:
          'Structured 4-week group therapy experiences for awareness, connection, and growth.',
      },
      {
        property: 'og:image',
        content: 'https://www.mannkaa.com/assets/img/service/grouptherapy/group-hero.png',
      },
      { property: 'og:url', content: canonicalUrl },
    ]);
  }


  ngOnInit() {
    
     const dpr = window.devicePixelRatio;
  this.isZoom110 = dpr >= 1.35 && dpr <= 1.4;

    this.contactForm = this.fb.group({
      fullName: ['', [Validators.required, Validators.minLength(3)]],
      age: ['', [Validators.required, Validators.pattern(/^[0-9]+$/)]],
      phoneNumber: ['', [
        Validators.required,
        Validators.pattern(/^[6-9]\d{9}$/)
      ]],
      email: ['', [
        Validators.required,
        Validators.email
      ]],
      location: ['', Validators.required],
      groups: [[], Validators.required]
    });
    // AOS.init({
    //   duration: 800,
    //   once: true
    // });
  }

  openTheme(theme: any) {

  if (window.innerWidth < 768) {

    const ref = this.bottomSheet.open(
    ThemeModalComponent,
    {
      data: theme,
      panelClass: 'theme-bottom-sheet'
    }
  );

     ref.afterDismissed().subscribe(result => {
      console.log(result)
    if (result === 'contact') {
      this.scrollToContact();
    }

  });

    return;
  }

  this.themeSelect(theme);
}

 onSubmit(): void {
  this.submitted = true;
  console.log('FORM STATUS:', this.contactForm.status);
console.log('FORM VALUE:', this.contactForm.value);
console.log('FORM INVALID:', this.contactForm.invalid);

    if (this.contactForm.invalid) {
    this.contactForm.markAllAsTouched();
    return;
  }

  const url = `${environment.baseUrl}/mobilewebController/userInformationForm`;

  const payload = {
    fullName: this.contactForm.value.fullName,
    Age: this.contactForm.value.age,
    Phonenumber: this.contactForm.value.phoneNumber,
    Email: this.contactForm.value.email,
    location: this.contactForm.value.location,
    problem_description: this.contactForm.value.groups
  };

  this.isSubmitting = true;

  this.commonService.postData<any>(url, payload)
    .pipe(finalize(() => {
      this.isSubmitting = false;
    }))
    .subscribe({
      next: (response) => {
        console.log('Success:', response);
        this.contactForm.reset();
        this.submitted = false;
        this.successTitle = 'Query Received';
        this.successMessage = 'We have received your query. Our health expert will get in touch with you in the next 24 Hours.';

        this.isSuccessModalVisible = true;
      },

      error: (error) => {
        console.error('Error:', error);
      }
    });
}

  toggleFaq(item: FaqItem) {
    this.faqs = this.faqs.map((faq) => ({
      ...faq,
      open: faq.id === item.id ? !faq.open : false,
    }));
  }

  configs: any = {
    therapySlider: {
      slidesPerView: 2,
      spaceBetween: 24,
      loop: false,

      speed: 700, // smooth snap

      grabCursor: true,



      mousewheel: {
        forceToAxis: true,
        sensitivity: 0.6,
        releaseOnEdges: true
      },

      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },

      navigation: false, // 

      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 12
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 16
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 24
        }
      }
    }
  };

  scrollToContact(): void {
    const element = document.getElementById('group-contact');

    if (element) {
      const yOffset = -150;
      const y =
        element.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;

      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  }

  themeSelect(theme: any) {
    this.showTheme.set(theme)
  }

  ngAfterViewInit(): void {


    // setTimeout(() => {
    //   AOS.init({
    //     duration: 800,
    //     once: false
    //   });

    //   AOS.refresh();
    // }, 100);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {

        if (entry.isIntersecting) {
          entry.target.classList.add('show');
        }
        else {
          entry.target.classList.remove('show');
        }

      });
    }, {
      threshold: 0.1
    });

    document.querySelectorAll('.animate')
      .forEach(el => observer.observe(el));

    document.querySelectorAll('.animate')
      .forEach(el => observer.observe(el));

    this.swiperRefs.forEach((swiper: ElementRef) => {

      new Swiper(swiper.nativeElement, this.configs.therapySlider);

    });

  }

}
